<script lang="ts">
    export let fillColor = 'white';
</script>

<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2092_120327)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.66213 11.933C5.63187 11.933 5.60734 11.9576 5.60734 11.9878C5.60734 12.0181 5.63187 12.0426 5.66213 12.0426C5.69239 12.0426 5.71692 12.0181 5.71692 11.9878C5.71692 11.9576 5.69239 11.933 5.66213 11.933ZM3.75 11.9878C3.75 10.9318 4.60609 10.0757 5.66213 10.0757C6.71817 10.0757 7.57426 10.9318 7.57426 11.9878C7.57426 13.0439 6.71817 13.8999 5.66213 13.8999C4.60609 13.8999 3.75 13.0439 3.75 11.9878Z"
            fill={fillColor}
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 11.933C11.9698 11.933 11.9452 11.9576 11.9452 11.9878C11.9452 12.0181 11.9698 12.0426 12 12.0426C12.0303 12.0426 12.0548 12.0181 12.0548 11.9878C12.0548 11.9576 12.0303 11.933 12 11.933ZM10.0879 11.9878C10.0879 10.9318 10.944 10.0757 12 10.0757C13.0561 10.0757 13.9122 10.9318 13.9122 11.9878C13.9122 13.0439 13.0561 13.8999 12 13.8999C10.944 13.8999 10.0879 13.0439 10.0879 11.9878Z"
            fill={fillColor}
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.3379 11.933C18.3077 11.933 18.2831 11.9576 18.2831 11.9878C18.2831 12.0181 18.3077 12.0426 18.3379 12.0426C18.3682 12.0426 18.3927 12.0181 18.3927 11.9878C18.3927 11.9576 18.3682 11.933 18.3379 11.933ZM16.4258 11.9878C16.4258 10.9318 17.2819 10.0757 18.3379 10.0757C19.394 10.0757 20.25 10.9318 20.25 11.9878C20.25 13.0439 19.394 13.8999 18.3379 13.8999C17.2819 13.8999 16.4258 13.0439 16.4258 11.9878Z"
            fill={fillColor}
        />
    </g>
    <defs>
        <clipPath id="clip0_2092_120327">
            <rect width="16.5" height="16.5" fill={fillColor} transform="translate(3.75 3.75)" />
        </clipPath>
    </defs>
</svg>
